var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChatDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 74.006,
    viewBox: "0 0 70 74.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_30179",
    x: 7,
    y: 0,
    width: 50.224,
    height: 59.006,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_904",
    x: 0,
    y: 53.006,
    width: 67,
    height: 21,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_903",
    "data-name": "Rectangle 903",
    width: 60,
    height: 53.079,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(-273 -494.994)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 273, 494.99)",
    filter: "url(#Path_30179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30179-2",
    "data-name": "Path 30179",
    d: "M9.127-3.529l3.149-.57L13.387-5.49l.813-.5h2.7l.15-.235L16.9-8.038l-.2-.387-.35-.3-.7-.479-.816-.609L14-10.55l-.613-.658-1.111-1.62L11.023-15.66l-.291-2.03-.179-.114H8.83l-.471-.084-.4-.09L7.346-18.3l-.6-.523-.4-.734-.112-.627v-.762l.275-.588.238-.375.262-.319.375-.288.35-.212.313-.125L8.425-23h.262l-.1-.6L8.35-24.691,8.125-25.8l-.087-1.225L7.95-28.434v-.937l.175-.812.225-.775.425-.8.625-.675.725-.613.988-.525.825-.475,1.283-1.042,1.648-1.1,1.263-.64,1.648-.514,1.291-.45,1.867-.214h1.214l3.356.214,3,.964,2.82,1.5,2.07,1.949,1.393,1.729.7,1.958.577,2.1.165,1.758-.165,1.291L35.733-23l1.044.354.714.769.412.961v1.05l-.412.879-.339.414L36.7-18.2l-.471.162-.487.211h-2.1l-.179.52-.276,1.528-.634,1.771-1.235,2.175-.851.961-.742.632L28.654-9.2l-1.318.779L27.2-6.946l-.165.721h1.982l.964.235.678.215.66.5.518.75,1.806.428,2.584.75,1.677.786,1.573.821L40.9-.564,41.975.721l.893,1.5,1.071,2.6.286,3.749v3.677L43.938,15H0L.563,4.119,4.029-1.387l2.721-1.5Z",
    transform: "translate(10 40.01)",
    fill: "#e0f0fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 273, 494.99)",
    filter: "url(#Rectangle_904)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_904-2",
    "data-name": "Rectangle 904",
    width: 61,
    height: 15,
    transform: "translate(3 55.01)",
    fill: "#e0f0fc"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Message_Dr.",
    "data-name": "Message Dr.",
    transform: "translate(280 561)",
    fontSize: 9,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Message Dr.")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(283 496.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M3.274,16.371v1.107H1.424V15.723l.966-.212A9.185,9.185,0,0,1,0,9.332,9.436,9.436,0,0,1,9.537,0a9.436,9.436,0,0,1,9.536,9.332,9.436,9.436,0,0,1-9.536,9.333A9.623,9.623,0,0,1,3.274,16.371Z",
    transform: "translate(38.225 14.249)",
    fill: "#003358",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30157",
    "data-name": "Path 30157",
    d: "M317.88,110.837h-1.945v-2.23h-2.752v2.23h-2.135v2.23h2.135v2.088h2.752v-2.088h1.945Z",
    transform: "translate(-266.893 -88.361)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30158",
    "data-name": "Path 30158",
    d: "M276.5,82.758a9.6,9.6,0,0,1-5.331-1.619.328.328,0,0,0-.385-.022q-1.513.781-3.034,1.546a.616.616,0,0,1-.921-.378.716.716,0,0,1,.1-.52c.5-1,1-2,1.5-3a.327.327,0,0,0-.014-.382,9.494,9.494,0,0,1-1.6-5.785,9.715,9.715,0,1,1,12.092,9.865,9.556,9.556,0,0,1-1,.2,9.007,9.007,0,0,1-1.416.1m-7.665-2.072.038.036c.562-.285,1.133-.553,1.682-.862a.86.86,0,0,1,1.039.082,8.194,8.194,0,0,0,6.579,1.424,8.488,8.488,0,1,0-10.1-9.055A8.136,8.136,0,0,0,269.6,77.94a.887.887,0,0,1,.08,1.064c-.3.549-.566,1.121-.845,1.683",
    transform: "translate(-228.822 -49.395)",
    fill: "#003358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30159",
    "data-name": "Path 30159",
    d: "M307.62,108.152c0-.363,0-.727,0-1.09a.617.617,0,0,1,.654-.654c.466-.005.932-.009,1.4,0,.171,0,.233-.033.227-.218-.014-.458-.007-.916,0-1.374a.627.627,0,0,1,.693-.686q1.055,0,2.109,0a.631.631,0,0,1,.7.706c0,.466.005.932,0,1.4,0,.135.04.176.174.174.474-.007.948-.005,1.422,0a.623.623,0,0,1,.681.674q.005,1.078,0,2.156a.62.62,0,0,1-.687.691c-.442.007-.885.012-1.327,0-.2-.006-.277.037-.267.256.019.426.007.853.005,1.279a.635.635,0,0,1-.707.72q-1.043,0-2.085,0a.635.635,0,0,1-.708-.72c0-.45-.009-.9,0-1.351,0-.173-.054-.211-.215-.205-.434.016-.868.015-1.3.022-.523.009-.76-.218-.762-.735,0-.347,0-.7,0-1.043m3.5-1.89c0,.221,0,.442,0,.664a.632.632,0,0,1-.7.707c-.45,0-.9.007-1.351,0-.165,0-.247.022-.231.215a4.574,4.574,0,0,1,0,.663c-.01.165.058.195.206.191.434-.012.869-.011,1.3-.014.547,0,.769.221.77.776,0,.442,0,.885,0,1.327,0,.135.04.179.174.174.237-.009.474-.01.711,0,.14.006.172-.048.17-.178-.007-.442,0-.885,0-1.327,0-.514.22-.739.729-.743.45,0,.9-.007,1.351,0,.157,0,.206-.048.2-.2-.012-.236-.01-.474,0-.711.006-.137-.044-.174-.176-.172-.466.007-.932,0-1.4,0a.632.632,0,0,1-.7-.7c0-.466,0-.932,0-1.4,0-.128-.027-.185-.169-.179-.237.011-.474.009-.711,0-.133-.005-.181.036-.175.172.01.245,0,.49,0,.735",
    transform: "translate(-263.942 -84.509)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30160",
    "data-name": "Path 30160",
    d: "M95.053,86.746a27.925,27.925,0,0,1-.694,2.977,11.2,11.2,0,0,1-5.042,6.088,2.468,2.468,0,0,0-.441.447,1.374,1.374,0,0,0-.432.04,11.57,11.57,0,0,1-9.783,0,1.38,1.38,0,0,0-.432-.04,3.118,3.118,0,0,0-.491-.472,11.535,11.535,0,0,1-5.461-7.645c-.1-.463-.152-.936-.226-1.4q0-.5-.008-1a7.792,7.792,0,0,1,.1-1.141c.323-1.4.675-2.795,1.023-4.19.21-.841.431-1.68.639-2.486a7.723,7.723,0,0,1,.774.1,50.656,50.656,0,0,0,7.65,1.2q3.213.26,6.433.435c1.047.056,2.1.01,3.148.01,1.5,0,1.518-.006,1.974,1.441.428,1.356.824,2.723,1.2,4.094a9.393,9.393,0,0,1,.175,1.313l-.105.236",
    transform: "translate(-61.403 -66.41)",
    fill: "#fad9be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30161",
    "data-name": "Path 30161",
    d: "M79.579,20.1a9.4,9.4,0,0,0-.175-1.314c-.376-1.371-.772-2.738-1.2-4.094-.456-1.447-.476-1.44-1.974-1.44-1.05,0-2.1.046-3.148-.01q-3.219-.171-6.433-.435a50.657,50.657,0,0,1-7.65-1.2,7.684,7.684,0,0,0-.774-.1c-.208.806-.429,1.644-.639,2.485-.348,1.395-.7,2.789-1.023,4.19a7.811,7.811,0,0,0-.1,1.14,2.807,2.807,0,0,1-.331-.47c-.556-1.275-1.1-2.556-1.644-3.836a22.62,22.62,0,0,1-.6-3.222c-.086-1.888-.484-3.855.782-5.565A5.231,5.231,0,0,1,56.767,4.56a7.5,7.5,0,0,0,1.662-1.07A14.435,14.435,0,0,1,65.071.328,16.87,16.87,0,0,1,68.364,0,15.116,15.116,0,0,1,74.9,1.476a12.218,12.218,0,0,1,6.283,6.037,11.4,11.4,0,0,1,.859,3.442,10.972,10.972,0,0,1-.448,4.161c-.086.278-.149.564-.261.831-.58,1.387-1.171,2.769-1.759,4.152",
    transform: "translate(-45.824 0)",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30162",
    "data-name": "Path 30162",
    d: "M215.847,227.492c2.147.525,4.377.742,6.361,1.849a11.467,11.467,0,0,1,5.134,5.7,12,12,0,0,1,.9,4.886c-.026,2.156-.016,4.312,0,6.468,0,.42-.093.575-.549.572-2.6-.022-5.2-.008-7.793-.016a2.448,2.448,0,0,1-.514-.112l1.034-.763a1.226,1.226,0,0,0,.2-.165,2.684,2.684,0,0,0-1.24-4.154q0-3.588,0-7.176l-3.532-7.092",
    transform: "translate(-183.965 -193.89)",
    fill: "#eeedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30163",
    "data-name": "Path 30163",
    d: "M4.462,247.594c-1.308,0-2.617-.009-3.925.01-.375.005-.514-.1-.512-.494.016-2.562-.085-5.128.034-7.684a11.005,11.005,0,0,1,2.973-7.058,11.658,11.658,0,0,1,6.526-3.63c.913-.182,1.833-.332,2.75-.5-.082.2-.151.412-.249.608q-1.583,3.188-3.173,6.373,0,2.26,0,4.52a5.071,5.071,0,0,0-4.311,4.329c-.135,1.163-.083,2.348-.116,3.523",
    transform: "translate(0 -194.529)",
    fill: "#eeedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30164",
    "data-name": "Path 30164",
    d: "M125.616,257.086H122.1l-.7-4.416c-.209-1.3-.427-2.589-.625-3.886-.257-1.677-.492-3.356-.747-5.033-.222-1.458-.458-2.914-.688-4.37.42.261.844.516,1.26.782a5.726,5.726,0,0,0,4.672.812,11.165,11.165,0,0,0,3.011-1.564c-.108.833-.2,1.669-.326,2.5-.424,2.8-.861,5.591-1.289,8.387-.121.79-.228,1.582-.341,2.373l-.7,4.416",
    transform: "translate(-101.708 -204.022)",
    fill: "#36a9d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30165",
    "data-name": "Path 30165",
    d: "M166.632,232.236c.113-.791.22-1.583.341-2.373.428-2.8.865-5.591,1.289-8.387.126-.831.218-1.666.326-2.5a2.551,2.551,0,0,0,.113-.354c.182-1.07.359-2.141.537-3.212.774,0,1.55-.025,2.321.018a2.745,2.745,0,0,1,2.341,1.761l3.532,7.092-1.752-.008c-.7,0-1.4.027-2.1-.016-.427-.026-.6.143-.65.529-.227,1.629-.474,3.255-.683,4.886-.1.786-.078.857-.842.775a4.438,4.438,0,0,0-3.553,1.086,7.24,7.24,0,0,1-1.222.7",
    transform: "translate(-142.02 -183.589)",
    fill: "#d8e0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30166",
    "data-name": "Path 30166",
    d: "M68.9,219c.23,1.457.466,2.912.688,4.37.255,1.677.491,3.356.747,5.033.2,1.3.416,2.591.625,3.886a3.98,3.98,0,0,1-.718-.368,5.216,5.216,0,0,0-4.332-1.4c-.376.07-.5-.171-.541-.461-.093-.6-.16-1.2-.241-1.793-.155-1.141-.316-2.281-.469-3.422-.052-.387-.223-.555-.65-.529-.7.043-1.4.014-2.1.016l-1.752.008q1.588-3.186,3.173-6.373c.1-.2.166-.4.249-.608.283-.376.552-.764.854-1.125a2.269,2.269,0,0,1,1.811-.753c.7-.012,1.393-.007,2.089-.01L68.9,219",
    transform: "translate(-51.269 -183.638)",
    fill: "#d9e0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30167",
    "data-name": "Path 30167",
    d: "M162.569,283.307a7.237,7.237,0,0,0,1.222-.7,4.438,4.438,0,0,1,3.553-1.086c.764.082.741.011.842-.775.21-1.631.456-3.257.683-4.886.054-.387.224-.555.65-.529.7.043,1.4.014,2.1.016q0,3.591,0,7.182a2.707,2.707,0,0,0-.008,5.084,2.445,2.445,0,0,1-.514.112q-4.615.008-9.229,0l.7-4.416",
    transform: "translate(-137.957 -234.66)",
    fill: "#eeeded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30168",
    "data-name": "Path 30168",
    d: "M114.721,207.59l-.565-3.533-.235-1.977a1.383,1.383,0,0,1,.431.04,11.57,11.57,0,0,0,9.783,0,1.374,1.374,0,0,1,.432-.04l-.253,1.974c-.178,1.071-.355,2.142-.537,3.212a2.55,2.55,0,0,1-.114.354,11.158,11.158,0,0,1-3.011,1.564,5.726,5.726,0,0,1-4.672-.812c-.416-.267-.84-.522-1.26-.782",
    transform: "translate(-97.095 -172.233)",
    fill: "#eda990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30169",
    "data-name": "Path 30169",
    d: "M72.015,275.345c.7,0,1.4.027,2.1-.016.427-.026.6.143.65.529.153,1.141.314,2.281.469,3.422.081.6.148,1.2.241,1.793.045.29.165.531.541.461a5.216,5.216,0,0,1,4.332,1.4,3.977,3.977,0,0,0,.718.368l.7,4.417H76.445c0-.884.007-1.768.005-2.651a5.318,5.318,0,0,0-3.62-5.022c-.272-.093-.54-.2-.81-.3q0-2.2,0-4.406",
    transform: "translate(-61.378 -234.659)",
    fill: "#eeeded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30170",
    "data-name": "Path 30170",
    d: "M49.187,323.344H42.1c0-.937-.011-1.874.01-2.811a3.261,3.261,0,0,1,1.157-2.466,3.384,3.384,0,0,1,3.936-.549,3.428,3.428,0,0,1,1.98,3.29c0,.845,0,1.69.005,2.535",
    transform: "translate(-35.878 -270.279)",
    fill: "#eeeded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30171",
    "data-name": "Path 30171",
    d: "M39.056,313.255c0-.845-.007-1.69-.005-2.536a3.428,3.428,0,0,0-1.98-3.29,3.384,3.384,0,0,0-3.936.549,3.261,3.261,0,0,0-1.157,2.465c-.021.937-.008,1.874-.01,2.811H30.209c.032-1.175-.019-2.36.116-3.523a5.071,5.071,0,0,1,4.311-4.329l1.753-.122c.27.1.538.207.81.3a5.319,5.319,0,0,1,3.62,5.022c0,.884,0,1.767-.005,2.651H39.056",
    transform: "translate(-25.747 -260.19)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30172",
    "data-name": "Path 30172",
    d: "M44.582,101.681c.547,1.279,1.089,2.56,1.645,3.836a2.8,2.8,0,0,0,.331.47q0,.5.008,1a13.887,13.887,0,0,1-2.3-.071,2.592,2.592,0,0,1-2.122-2.742,2.744,2.744,0,0,1,2.439-2.494",
    transform: "translate(-35.916 -86.662)",
    fill: "#eea990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30173",
    "data-name": "Path 30173",
    d: "M227.926,107.325c.588-1.384,1.179-2.765,1.759-4.152.112-.267.175-.553.261-.831a2.566,2.566,0,0,1,2.123,3.234,2.621,2.621,0,0,1-2.595,1.979c-.551,0-1.1,0-1.653.006l.105-.236",
    transform: "translate(-194.171 -87.226)",
    fill: "#eda990"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30174",
    "data-name": "Path 30174",
    d: "M217.6,328.617a2.707,2.707,0,0,1,.008-5.084l.665-.093a2.565,2.565,0,0,0-.413,2.882,2.628,2.628,0,0,0,2.541,1.533l-1.035.763H217.6",
    transform: "translate(-183.95 -275.666)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30175",
    "data-name": "Path 30175",
    d: "M228.548,282.539l-.665.093q0-3.591,0-7.182l1.752.008q0,3.588,0,7.176l-1.092-.1",
    transform: "translate(-194.224 -234.765)",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30176",
    "data-name": "Path 30176",
    d: "M228.406,323.44l1.092.1a2.684,2.684,0,0,1,1.24,4.154,1.215,1.215,0,0,1-.2.165,2.628,2.628,0,0,1-2.541-1.533,2.565,2.565,0,0,1,.413-2.882",
    transform: "translate(-194.081 -275.666)",
    fill: "#808181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30177",
    "data-name": "Path 30177",
    d: "M61.911,279.857l-1.753.122q0-2.26,0-4.52l1.752-.008q0,2.2,0,4.406",
    transform: "translate(-51.269 -234.765)",
    fill: "#373737"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatDoctor);
export default __webpack_public_path__ + "static/media/icon_chat_doctor.7eeff5241923362a198378206a2e49a8.svg";
export { ForwardRef as ReactComponent };